<div class="app-header header-shadow">

  <!-- Logo strip (sits over sidebar) -->
  <div class="app-header__logo">
    <div class="logo-src">
      <i class="pe-7s-bookmarks"></i>
      <div class="hdr-brand-block">
        <span class="hdr-brand-name">BookBridge</span>
        <span class="hdr-licensed" *ngIf="clientName">Licensed to: {{ clientName }}</span>
      </div>
    </div>
    <div class="header__pane ml-auto">
      <button type="button" (click)="onToggleSidebar()" class="hamburger close-sidebar-btn hamburger--elastic"
        data-class="closed-sidebar">
        <i class="pe-7s-menu" style="font-size:1.3rem;"></i>
      </button>
    </div>
  </div>

  <!-- Mobile menu toggle -->
  <div class="app-header__mobile-menu">
    <button type="button" (click)="onToggleSidebar()" class="hamburger hamburger--elastic mobile-toggle-nav">
      <i class="pe-7s-menu" style="font-size:1.3rem;"></i>
    </button>
  </div>

  <!-- Header content -->
  <div class="app-header__content">

    <!-- Left: page context -->
    <div class="app-header-left">
      <div class="ms-2 d-none d-md-block">
        <div class="hdr-page-title">{{ pageTitle.title }}</div>
        <div class="hdr-page-sub">{{ pageTitle.subtitle }}</div>
      </div>
    </div>

    <!-- Divider + Quick Access center section (only when items pinned) -->
    <ng-container *ngIf="(qa.items$ | async)?.length">
      <div class="hdr-divider"></div>
      <div class="hdr-qa-section">
        <span class="hdr-qa-label">Quick Access</span>
        <div class="hdr-qa-icons">
          <div *ngFor="let item of qa.items$ | async" class="hdr-qa-icon-wrap">
            <button
              class="hdr-qa-icon"
              [class.hdr-qa-icon--active]="qaIsActive(item.route)"
              (click)="qaNavigate(item.route)"
              [title]="item.label">
              <i [class]="item.icon"></i>
            </button>
            <button
              class="hdr-qa-remove"
              (click)="$event.stopPropagation(); qa.unpin(item.route)"
              title="Remove from Quick Access">
              &times;
            </button>
          </div>
        </div>
      </div>
      <div class="hdr-divider"></div>
    </ng-container>

    <!-- Right: user -->
    <div class="app-header-right">
      <div class="header-btn-lg pr-0">
        <div class="widget-content p-0">
          <div class="widget-content-wrapper align-items-center">

            <!-- Name + role + context chip (desktop) -->
            <div class="me-3 d-none d-md-flex flex-column align-items-end">
              <div class="hdr-user-name">{{ currentUser?.name || 'User' }}</div>
              <div class="hdr-user-role">{{ currentUser?.role }}</div>

              <!-- License chip — non-managers only -->
              <div *ngIf="!isManager && licenseChip" class="hdr-lic-chip {{ licenseChip.cls }}">
                <i class="pe-7s-shield"></i> {{ licenseChip.label }}
              </div>

              <!-- Center chip — managers only -->
              <div *ngIf="isManager" class="position-relative">
                <div class="hdr-center-chip"
                     [class.hdr-center-chip--clickable]="managerCenters.length > 1"
                     [class.hdr-center-chip--unset]="!selectedCenter"
                     (click)="managerCenters.length > 1 ? toggleCenterMenu($event) : null">
                  <i class="pe-7s-home"></i>
                  <span>{{ selectedCenter?.centerName || 'Select Center' }}</span>
                  <i *ngIf="managerCenters.length > 1" class="pe-7s-angle-down hdr-center-chip-caret"></i>
                </div>
                <div class="hdr-center-dropdown" *ngIf="isCenterMenuOpen">
                  <div class="hdr-cd-header">Switch Center</div>
                  <button class="hdr-cd-item"
                          *ngFor="let c of managerCenters"
                          [class.active]="selectedCenter?._id === c._id"
                          (click)="selectCenter(c)">
                    <div class="hdr-cd-dot" [class.active]="selectedCenter?._id === c._id"></div>
                    <div class="hdr-cd-info">
                      <span class="hdr-cd-name">{{ c.centerName }}</span>
                      <span class="hdr-cd-sub" *ngIf="c.area">{{ c.area }}</span>
                    </div>
                    <i class="pe-7s-check hdr-cd-check" *ngIf="selectedCenter?._id === c._id"></i>
                  </button>
                </div>
              </div>

            </div>

            <!-- Avatar + dropdown -->
            <div class="position-relative">
              <div class="user-avatar" (click)="toggleUserMenu($event)">
                <img *ngIf="profilePic" [src]="profilePic" alt="Profile" class="user-avatar-img">
                <span *ngIf="!profilePic">{{ (currentUser?.name || 'U').charAt(0).toUpperCase() }}</span>
              </div>

              <div class="hdr-dropdown" *ngIf="isUserMenuOpen" (click)="$event.stopPropagation()">

                <div class="hdr-dd-user">
                  <div class="hdr-dd-user-info">
                    <div class="dd-name">{{ currentUser?.name }}</div>
                    <div class="dd-email">{{ currentUser?.email }}</div>
                  </div>
                  <button class="hdr-dd-close" type="button" (click)="isUserMenuOpen = false" title="Close">&#x2715;</button>
                </div>

                <button class="hdr-dd-item" type="button" (click)="goToProfile()">
                  <i class="pe-7s-user"></i>
                  My Profile
                </button>

                <button class="hdr-dd-item" type="button" (click)="openCpModal()">
                  <i class="pe-7s-lock"></i>
                  Change Password
                </button>

                <div class="hdr-dd-divider"></div>

                <!-- Theme picker -->
                <div class="hdr-dd-theme">
                  <span class="hdr-dd-theme-label">Theme</span>
                  <div class="hdr-dd-theme-swatches">
                    <button
                      class="hdr-theme-swatch"
                      [class.hdr-theme-swatch--active]="currentTheme === 'brown'"
                      (click)="setTheme('brown')"
                      title="Brown & Cream">
                      <span class="hdr-swatch-dot hdr-swatch-dot--brown"></span>
                      <span class="hdr-swatch-name">Brown</span>
                      <i *ngIf="currentTheme === 'brown'" class="pe-7s-check hdr-swatch-check"></i>
                    </button>
                    <button
                      class="hdr-theme-swatch"
                      [class.hdr-theme-swatch--active]="currentTheme === 'indigo'"
                      (click)="setTheme('indigo')"
                      title="Indigo & White">
                      <span class="hdr-swatch-dot hdr-swatch-dot--indigo"></span>
                      <span class="hdr-swatch-name">Indigo</span>
                      <i *ngIf="currentTheme === 'indigo'" class="pe-7s-check hdr-swatch-check"></i>
                    </button>
                  </div>
                </div>

                <div class="hdr-dd-divider"></div>

                <button class="hdr-dd-item danger" type="button" (click)="logout()">
                  <i class="pe-7s-power"></i>
                  Sign Out
                </button>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- ── Change Password Modal ──────────────────────────────────────────────── -->
<div *ngIf="showCpModal" class="cp-overlay" (click)="closeCpModal()">
  <div class="cp-modal" (click)="$event.stopPropagation()">

    <div class="cp-header">
      <span><i class="pe-7s-lock me-2"></i>Change Password</span>
      <button class="cp-close" (click)="closeCpModal()">&#x2715;</button>
    </div>

    <div class="cp-body">

      <div class="cp-field">
        <label class="cp-label">Current Password</label>
        <div class="cp-input-wrap">
          <input [type]="showCpCurrent ? 'text' : 'password'" [(ngModel)]="cpCurrent"
                 class="form-control form-control-sm" placeholder="Enter current password" />
          <button type="button" class="cp-eye" (click)="showCpCurrent = !showCpCurrent" tabindex="-1">
            <i [class]="showCpCurrent ? 'pe-7s-close-circle' : 'pe-7s-look'"></i>
          </button>
        </div>
      </div>

      <div class="cp-field">
        <label class="cp-label">New Password</label>
        <div class="cp-input-wrap">
          <input [type]="showCpNew ? 'text' : 'password'" [(ngModel)]="cpNew"
                 class="form-control form-control-sm" placeholder="Enter new password" />
          <button type="button" class="cp-eye" (click)="showCpNew = !showCpNew" tabindex="-1">
            <i [class]="showCpNew ? 'pe-7s-close-circle' : 'pe-7s-look'"></i>
          </button>
        </div>
        <div class="pw-rules mt-2">
          <div class="pw-rule" [class.pw-rule--met]="cpHas8">Minimum 8 characters</div>
          <div class="pw-rule" [class.pw-rule--met]="cpHasUpper">At least 1 uppercase letter (A–Z)</div>
          <div class="pw-rule" [class.pw-rule--met]="cpHasLower">At least 1 lowercase letter (a–z)</div>
          <div class="pw-rule" [class.pw-rule--met]="cpHasNumber">At least 1 number (0–9)</div>
          <div class="pw-rule" [class.pw-rule--met]="cpHasSpecial">At least 1 special character (@, $, !, %)</div>
        </div>
      </div>

      <div class="cp-field">
        <label class="cp-label">Confirm New Password</label>
        <div class="cp-input-wrap">
          <input [type]="showCpConfirm ? 'text' : 'password'" [(ngModel)]="cpConfirm"
                 class="form-control form-control-sm" placeholder="Re-enter new password" />
          <button type="button" class="cp-eye" (click)="showCpConfirm = !showCpConfirm" tabindex="-1">
            <i [class]="showCpConfirm ? 'pe-7s-close-circle' : 'pe-7s-look'"></i>
          </button>
        </div>
        <div class="cp-mismatch" *ngIf="cpConfirm && cpNew !== cpConfirm">
          Passwords do not match.
        </div>
      </div>

      <div class="cp-error"   *ngIf="cpError">{{ cpError }}</div>
      <div class="cp-success" *ngIf="cpSuccess">{{ cpSuccess }}</div>

    </div>

    <div class="cp-footer">
      <button class="cp-btn cp-btn--cancel" (click)="closeCpModal()">Cancel</button>
      <button class="cp-btn cp-btn--save" (click)="submitCpModal()" [disabled]="!cpIsValid || cpSaving">
        <span *ngIf="!cpSaving">Change Password</span>
        <span *ngIf="cpSaving" class="d-flex align-items-center gap-1">
          <span class="spinner-border spinner-border-sm"></span> Saving...
        </span>
      </button>
    </div>

  </div>
</div>